import { ALPHANUMERIC_CODES_BASE } from '../constant/CustomerDocumentTypes';

/**
 * Construye un Set de códigos alfanuméricos que existan en la lista de tipos de documento
 */
export const buildAlphanumericCodeSet = (
  documentTypes = [],
  baseList = ALPHANUMERIC_CODES_BASE
) => {
  const codesInPayload = new Set(documentTypes.map((d) => Number(d.codigo)));
  return new Set(baseList.filter((c) => codesInPayload.has(Number(c))));
};

/**
 * Obtiene el código a partir de un id
 */
export const getDocumentCodeById = (documentTypes = [], id) => {
  const doc = documentTypes.find((x) => Number(x.id) === Number(id));
  return doc ? Number(doc.codigo) : null;
};

/**
 * Obtiene el nombre por id
 */
export const getDocumentNameById = (documentTypes = [], id) => {
  const doc = documentTypes.find((x) => Number(x.id) === Number(id));
  return doc ? doc.nombre : null;
};

/**
 * Obtiene el documento por código
 */
export const getDocumentByCode = (documentTypes = [], codigo) => {
  return documentTypes.find((x) => Number(x.codigo) === Number(codigo)) || null;
};

/**
 * Valida si un código es alfanumérico
 */
export const isAlphanumericByCode = (alnumSet, codigo) => {
  if (!alnumSet) return false;
  if (codigo == null) return false;
  return alnumSet.has(Number(codigo));
};

/**
 * Valida si un id corresponde a documento alfanumérico
 */
export const isAlphanumericById = (documentTypes = [], alnumSet, id) => {
  const codigo = getDocumentCodeById(documentTypes, id);
  return isAlphanumericByCode(alnumSet, codigo);
};
